module.exports = __webpack_public_path__ + "img/scissors-lg.33355c7b.png";